export class VendorErrorCodeApiError extends Error {
  public constructor(
    public readonly status?: number,
    message = 'Vendor error code request failed',
  ) {
    super(message);
    this.name = 'VendorErrorCodeApiError';
  }
}
